module.exports = __webpack_public_path__ + "img/axel-success.a6272e66.svg";